/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthenticateResultModel { 
    status?: number;
    accessToken?: string | null;
    encryptedAccessToken?: string | null;
    expireInSeconds?: number;
    userId?: number;
    message?: string | null;
    roles?: Array<string> | null;
    isFcmTokenAvailiable?: boolean;
    tenantId?: number | null;
    isSuperAdmin?: boolean | null;
    isSuccess?: boolean | null;
    decription?: string | null;
    requireOTP?: boolean;
    userToken?: string | null;
}

